import { ItineraryActions } from '~/actions/trip/itinerary'
import { TranslationService } from '~/services/Translation'

export default defineNuxtRouteMiddleware(async (to) => {
	if (import.meta.server) return

	const nuxtApp = useNuxtApp()
	try {
		TranslationService.getInstance(nuxtApp.$i18n)
		const itineraryId = to.params.itinerary_id as string
		const itineraryOptions = await ItineraryActions.getTripOptions(itineraryId)
		const allowedRoles = ['owner', 'manager', 'viewer']
		const canAccessToItinerary = allowedRoles.includes(itineraryOptions?.role || '')
		if (!canAccessToItinerary)
			throw createError({ status: 404, statusText: 'Trip Not Found', fatal: true })
	} catch (e) {
		console.error(e)
		throw createError({ status: 404, statusText: 'Trip Not Found', fatal: true })
	}
})
